module.exports = __webpack_public_path__ + "img/feature-usersegmentation-2.90f97962.jpg";